(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["neonbir-isigini-sec"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nb-light-gallery')) {
  customElements.define('nb-light-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const controller = new AbortController();
      this.cleanup = controller;
      this.buttons = Array.from(this.querySelectorAll('[data-choice]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      const choices = this.querySelector('.nb-gallery__choices');
      if (!choices || !this.buttons.length || this.buttons.length !== this.panels.length) return;
      choices.setAttribute('role', 'tablist');
      this.buttons.forEach(button => button.setAttribute('role', 'tab'));
      this.panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        const button = this.buttons.find(item => item.dataset.choice === panel.dataset.panel);
        panel.setAttribute('aria-labelledby', button.id);
      });
      this.select(this.buttons[0].dataset.choice, false);
      this.classList.add('is-ready');
      choices.hidden = false;
      choices.addEventListener('click', event => {
        const button = event.target.closest('[data-choice]');
        if (button) this.select(button.dataset.choice, true);
      }, {signal: controller.signal});
      choices.addEventListener('keydown', event => {
        const button = event.target.closest('[data-choice]');
        if (!button) return;
        let index = this.buttons.indexOf(button);
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') index = (index + 1) % this.buttons.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') index = (index - 1 + this.buttons.length) % this.buttons.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.buttons.length - 1;
        else return;
        event.preventDefault();
        this.buttons[index].focus();
        this.select(this.buttons[index].dataset.choice, true);
      }, {signal: controller.signal});
      document.addEventListener('shopify:block:select', event => {
        if (event.detail && this.panels.some(panel => panel.dataset.panel === event.detail.blockId)) this.select(event.detail.blockId, false);
      }, {signal: controller.signal});
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.classList.add('is-inview');
            this.observer.disconnect();
          }
        }, {threshold: 0.15});
        this.observer.observe(this);
      } else this.classList.add('is-inview');
    }
    select(id, animate) {
      if (this.selected === id) return;
      this.selected = id;
      this.buttons.forEach(button => {
        const active = button.dataset.choice === id;
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => {
        const active = panel.dataset.panel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-entering', active && animate);
      });
    }
    disconnectedCallback() {
      if (this.cleanup) this.cleanup.abort();
      if (this.observer) this.observer.disconnect();
      this.cleanup = null;
      this.selected = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
